export const GAME_CAST_REQUEST_TIMEOUT = 0.2 * 60 * 1000;

export const disallowKeyCode = [''];

export const enableDebug = false;